module.exports = __webpack_public_path__ + "public/images/schedule/schedule-pattern-3.5257ba3c15e2501387759886e5cae630.png";